// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'licenses'"
        editRoute="licenseEdit"
        :headers="headers"
        id="fingerprint"
        name="License"
        :searchBarText="searchBarText"
        pagination
        permissions="licenses"
        ></item-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import moment from 'moment'
import ItemList from 'vue-common/components/ItemList.vue'
import {ENDPOINT} from '@/shared/constants'

export default {
  components: {
    ItemList
  },

  props: {
    searchBarText: String
  },

  data () {
    return {
      endpoint: ENDPOINT,
      headers: [
        {
          text: 'Customer',
          value: 'customer',
          context: ENDPOINT + 'customers',
          itemValue: '_id',
          itemText: 'name'
        },
        {
          text: 'Item',
          value: 'item',
          context: ENDPOINT + 'items',
          itemValue: '_id',
          itemText: 'name'
        },
        {
          text: 'Fingerprint',
          value: 'fingerprint'
        },
        {
          text: 'Expires',
          value: 'expires',
          function: this.formatDate
        },
        {
          text: 'Last Active',
          value: 'timeAccessed',
          function: this.formatAccessDate
        },
        {
          text: 'Active',
          value: 'active',
          type: 'checkbox'
        }
      ]
    }
  },

  methods: {
    formatDate: function (item) {
      var t = moment(item.expires)
      if (t.isBefore('1000-01-01')) {
        return 'N/A'
      }
      return t.format('YYYY-MM-DD')
    },

    formatAccessDate: function (item) {
      var t = moment(item.timeAccessed)
      if (t.isBefore('1000-01-01')) {
        return 'N/A'
      }
      return t.format('YYYY-MM-DD')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Licenses.vue